// extracted by mini-css-extract-plugin
module.exports = {"actions":"calendars_actions__Vulj-","btnLink":"calendars_btnLink__2Lojo"};